export const loadAnimationConstants = {
  LOADING_BEGIN: 'LOADING_BEGIN',
  LOADING_END: 'LOADING_END'
};
